'use client';

import React, { useContext } from 'react';
import BairesDevHeader from 'layout/src/components/header';
import newHeaderData from 'app/data/menu';
import LinkOrButton from 'layout/src/components/SecondaryNavigation/Links/_LinkOrButton';
import DropdownContext from 'layout/src/components/SecondaryNavigation/_dropdownContext';
import useWindowSize from 'ui/src/hooks/useWindowSize';
import twMerge from 'utilities/src/twMerge';
import IconComponent from 'ui/src/components/Icon';

export const headerButtonId = 'blog-button';

export default function Header() {
  const { isOpen, setIsOpen } = useContext(DropdownContext);
  const { isMdS } = useWindowSize({ mdS: 640 });
  return (
    <BairesDevHeader
      animatedHeader={false}
      enableHeaderBehavior
      menuItems={newHeaderData}
      logoPath={`${process.env.NEXT_PUBLIC_BASE_PATH}/bairesdev-logo-light.svg`}
      headerLinkChildren={
        <>
          <div className="bg-site-neutrals-50 mx-5 w-0.5 self-stretch rounded" />
          <LinkOrButton
            id={headerButtonId}
            isLink={isMdS}
            onClick={() => setIsOpen(!isOpen)}
            href={`${process.env.NEXT_PUBLIC_HOSTNAME}${process.env.NEXT_PUBLIC_BASE_PATH}`}
            className="site-display-xs text-site-neutrals-800 flex items-center gap-1 font-light"
          >
            <span>Blog</span>
            <IconComponent
              iconName="ChevronRightSmall"
              size="IconM"
              className={twMerge('mdS:hidden rotate-90 bg-current', { '-rotate-90': isOpen })}
            />
          </LinkOrButton>
        </>
      }
    />
  );
}
